import { render } from "./SpinLoader.vue?vue&type=template&id=7c4b057e&scoped=true"
import script from "./SpinLoader.vue?vue&type=script&lang=js"
export * from "./SpinLoader.vue?vue&type=script&lang=js"

import "./SpinLoader.vue?vue&type=style&index=0&id=7c4b057e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4b057e"]])

export default __exports__